<script>
export default {
  name: 'ServiceJp'
}
</script>

<template lang="pug" src="./ServiceJp.pug"></template>
<style lang="scss" src="./ServiceJp.scss" scoped></style>
